/**
 * Submittals Not Tracked badge (log/menu).
 * Design: 42×42 container (black 15% opacity) + folder with prohibited mark.
 */
export default function SubmittalUntrackedCiqIcon({
  size = 42,
  className = ""
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="42" height="42" rx="4" fill="black" fillOpacity="0.15" />
      <path
        d="M21.2415 15.2753H30.8576C31.3317 15.2753 31.7147 15.6584 31.7147 16.1325V24.7672C31.7147 24.7672 31.2453 24.0878 30.8576 23.7356C30.4819 23.3944 29.7861 23 29.7861 23V17.2039H20.4674L17.2638 14.1396H12.2147V27.8539H22.5C22.5 28.5 22.4784 29.1405 23.1059 29.7825H11.1433C10.6692 29.7825 10.2861 29.3994 10.2861 28.9253V13.0682C10.2861 12.5941 10.6692 12.211 11.1433 12.211H17.9522C18.007 12.2115 18.0595 12.2325 18.0995 12.27L21.2415 15.2753Z"
        fill="black"
        fillOpacity="0.45"
      />
      <circle
        cx="27.5"
        cy="27.5"
        r="3.8"
        stroke="black"
        strokeOpacity="0.45"
        strokeWidth="1.4"
      />
      <path
        d="M30 30L25.5 25"
        stroke="#777777"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}
